import { useEffect, useState } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { LangContext } from "@/i18n";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Manifesto from "@/components/landing/Manifesto";
import HowItWorks from "@/components/landing/HowItWorks";
import CreditPacks from "@/components/landing/CreditPacks";
import AppPreview from "@/components/landing/AppPreview";
import RewardsStore from "@/components/landing/RewardsStore";
import Winners from "@/components/landing/Winners";
import Waitlist from "@/components/landing/Waitlist";
import FAQ from "@/components/landing/FAQ";
import Countdown from "@/components/landing/Countdown";
import DownloadCTA from "@/components/landing/DownloadCTA";
import Footer from "@/components/landing/Footer";
import Termos from "@/pages/Termos";
import Privacidade from "@/pages/Privacidade";
import JogoResponsavel from "@/pages/JogoResponsavel";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <HowItWorks />
        <CreditPacks />
        <AppPreview />
        <RewardsStore />
        <Winners />
        <Waitlist />
        <FAQ />
        <Countdown />
        <DownloadCTA />
      </main>
      <Footer />
    </>
  );
}

function App() {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("duelo-lang") || "pt"
  );
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("duelo-lang", l);
  };

  return (
    <LangContext.Provider value={{ lang, setLang }}>
      <div className="App" data-testid="app-root">
        <Toaster theme="dark" richColors position="top-center" />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/termos" element={<Termos />} />
            <Route path="/privacidade" element={<Privacidade />} />
            <Route path="/jogo-responsavel" element={<JogoResponsavel />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
          </Routes>
        </BrowserRouter>
      </div>
    </LangContext.Provider>
  );
}

export default App;
